module.exports = "<div class=\"error\">\n  <div class=\"show\">\n    <img class=\"animated bounce infinite\" src=\"https://www.youtube.com/yts/img/ringo/img/image-hh-404-vflP3hqNT.png\" alt=\"Error thumbnail\"><br/>\n    <span style=\"display: block; margin-left:22%;\">{{ message }}</span>\n    <span>Try <a routerLink=\"/about\">&nbsp;something&nbsp;</a> else...</span><br/>\n    <a routerLink=\"/search\"><button class=\"btn btn-default\"><i class=\"fa fa-search\"></i>&nbsp;Search</button></a>\n  </div>\n</div>\n\n<app-footer></app-footer>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/not-found/not-found.component.html
// module id = ./src/app/not-found/not-found.component.html
// module chunks = main